import { Injectable } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { ApiClient } from '../common/api-client.service';

export interface Txn {
  id: number;
  amount: number;
  ledger_id: number;
  date: string;
  fund: any;
  account: any;
  tags: string[];
}

export interface TxnFilter {
  start_date?: string;
  end_date?: string;
  'account_ids[]'?: number[];
  'funds_ids[]'?: number[];
  limit: number;
  order: string;
}

@Injectable()
export class TxnService {
  constructor(
    private apiClient: ApiClient,
  ) {}

  query(filter: TxnFilter): Observable<Txn[]> {
    return this.apiClient.get<Txn[]>('/api/v1/transactions', filter);
  }
}

@Injectable()
export class TxnDataSource extends DataSource<Txn> {
  filterChange = new BehaviorSubject(<TxnFilter> {});
  get filter(): TxnFilter { return this.filterChange.value }
  set filter(f: TxnFilter) { this.filterChange.next(f) }

  constructor(
    private txnService: TxnService,
  ) {
    super();
  }

  reload(): void {
    this.filterChange.next(this.filterChange.value);
  }

  connect(): Observable<Txn[]> {
    const changes = [
      this.filterChange,
    ]

    return Observable.merge(...changes).switchMap(() => {
      return this.txnService.query(this.filter);
    });
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// /srv/src/app/txns/txn.service.ts